<template>
  <div class="bg-gray">
    <div class="container-fluid">
      <div class="user-card">
        <h2>Flagged Me's</h2>

        <div class="row"
            v-for="(me, index) in results" :key="index"
        >
          <div class="col-sm-12" v-if="me">
            <div v-if="me.photo">
              <img 
                :src="me.photoUrl"
                style="height: 200px"
              />
            </div>

            <router-link v-if="me.user" :to="`/users/${me.user.id}`">{{me.user.firstName}} {{me.user.lastName}} ({{me.user.username}})</router-link>
            <br><br>

            <button @click="review(me, true)" class="btn btn-default">Mark Reviewed</button>
            <br><br>
            <button @click="review(me, false)" class="btn btn-danger">Remove Me</button>
            <hr>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { StoreActions } from "./store/actions";
import StoreIndex from "./store/_StoreIndex";
import {StoreState as state} from './store/state'

export default {
  name: "FlaggedMes",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.dispatch(StoreActions.getFlagged);
    },
    commit(path, value) {
      this.$store.commit(`${StoreIndex.path}/${path}`, value);
    },
    dispatch(path, value) {
      this.$store.dispatch(`${StoreIndex.path}/${path}`, value);
    },
    review(me, approved) {
      this.dispatch(StoreActions.reviewedReported, {
        id: me.id,
        approved: approved
      });
    },
  },
  computed: {
    ...mapState(StoreIndex.path,[
      state.results
    ])
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-header {
  background: #46c3f0;
  color: white;
}
a {
  color: black;
  font-weight: bold;
}

.btn-secondary {
  background: lightgray;
  border-color: lightgray;
}

@media (max-width: 700px) {
  .mobile-hide {
    display: none;
  }
}

@media (min-width: 701px) {
  .large-hide {
    display: none;
  }
}

.user-card {
  background: white;
  margin: 20px;
  border-radius: 10px;
}

.user-img {
  border-radius: 10px;
  margin: 10px;
}

label {
  color: gray;
  font-weight: bold;
}

.user-photo {
  width:100px;
  height:100px;
  border-radius: 50px;
  object-fit: cover;
}

@media (max-width:767px) {
  .user-photo {
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }
}
</style>